import { Injectable } from "@angular/core";
import { DataProvider2 } from "./provider/data2.provider";

interface IMetricResult {
	paidCount: number;
}

@Injectable()
export class MetriksService {
	constructor(
		public dp: DataProvider2,
	) {

	}

	get(qs: object) {
		return this.dp.get<IMetricResult[]>('/metric_builder', qs);
	}
}
